<div data-cy="shared-project-chat-panel__page" class="channel-container">
    <div class="d-flex align-items-center gap-6 py-16 px-36">
        <i data-cy="shared-project-chat-panel__go-back" class="uil uil-angle-left-b unicon-icon d-text-middle pointer" (click)="goBack()"></i>
        <h2 class="d-text-bold d-text-uppercase">{{ data.name | capitaliz }}</h2>
    </div>
    <mat-divider></mat-divider>

    <mat-progress-bar mode="indeterminate" class="mt-10" *ngIf="isLoading()"></mat-progress-bar>

    <ng-container *ngIf="!isLoading()">
        <div class="col-xs-12 pl-0 pr-0 border-b">
            <div class="d-flex align-items-center space-between pl-20 pr-16 pt-8 relative">
                <div class="d-flex gap-30 pt-12">
                    <div class="tab pb-10 pl-3 pr-3" [ngClass]="{ 'active': selectedTab === 'chatten' }"  (click)="selectTab('chatten')">Chatten</div>
                    <!-- <div class="tab pb-10 pl-3 pr-3" [ngClass]="{ 'disabled-link': selectedTab === 'volgers' }">Volgers</div> -->
                </div>
                <!-- <button mat-stroked-button (click)="toggleChannelDropdown()" class="disabled-link">Item Channel</button> -->
                <div class="channel-dropdown" *ngIf="isDropdownOpen">
                    <span class="d-flex direction-column gap-8">
                        <span class="fs-22">Item channel</span>
                        <p>Select an item to view the item channel</p>
                    </span>
                    <div class="d-flex direction-column">
                        <app-generic-multiselect-checkbox data-cy="shared-project-chat-panel__generic-multiselect-checkbox" class="full-width" [placeholder]="'users.add_users' | transloco" name="users" [(ngModel)]="users" ngDefaultControl [uniqueId]="'add-users'">
                            <app-generic-multiselect-checkbox-option *ngFor="let user of this.collaboratorUsers" [value]="user">
                                {{ user.name }}
                            </app-generic-multiselect-checkbox-option>
                        </app-generic-multiselect-checkbox>

                        <button data-cy="shared-project-chat-panel__btn" mat-stroked-button class="col-xs-7">Go to item Channel <i class="uil uil-angle-right-b"></i></button>
                    </div>

                </div>
            </div>
        </div>

        <div *ngIf="selectedTab === 'chatten'" class="tab-content" #scrollContainer>
            <div class="column-8" *ngFor="let msg of messages().slice().reverse()" 
                [class.align-end]="isMyMessage(msg)">
                <!-- temp: not show user added as collaborator -->
                <span class="pl-6 pb-6" *ngIf="msg.message.message !== 'User attached as a collaborator'"> 
                    {{msg.updated_at | date:'MMM d, y, h:mm' | capitaliz}} 
                </span>
                <div class="msg-box" 
                    *ngIf="msg.message.message !== 'User attached as a collaborator'"
                    [style.background-color]="getMessageBackgroundColor(msg)"
                    [style.color]="getMessageTextColor(msg)">
                    <h4 [style.font-weight]="600" 
                        [style.color]="getMessageTextColor(msg)" 
                        class="mb-0 mt-0">
                        {{msg.users.name}}
                    </h4>
                    <p [innerHTML]="msg.message.message" 
                    [style.color]="getMessageTextColor(msg)">
                    </p>
                    <div class="flex ml-10" *ngIf="!isMyMessage(msg)">
                        <i *ngIf="msg.message.message !== 'User attached as a collaborator'" class="prj-name ml-auto">{{msg.message.project | capitaliz }}</i>
                    </div>                    
                </div>
            </div>

            <div *ngIf="isSending()" class="align-end">
                <mat-spinner diameter="15"></mat-spinner>
            </div>
        </div>

        <div *ngIf="selectedTab === 'volgers'" class="tab-content">
            <p>This is Volgers content</p>
        </div>

        <mat-divider></mat-divider>
        <div class="chat-input">
            <div class="pl-30 pr-30 pb-15 pt-15">
                <div class="custom-input">
                    <div #textareaRef
                        id="message-text-area"
                        class="divtextarea custome-textarea update-textarea"
                        contenteditable="true"
                        [mentionConfig]="mentionConfig"
                        (searchTerm)="loadItems($event)"
                        (itemSelected)="itemSelected($event)"
                        (input)="onChangeComment($event.target.innerHTML)"
                        (keydown.enter)="onEnterPress($event)"
                        [data-placeholder]="'Type a message...'"
                        [ngClass]="{'disable_enitiy': isSending()}">
                    </div>
                    <span data-cy="shared-project-chat-panel__send-message"
                        [class.pointer]="!cleanMessage(commentEntity.message).length"
                        [disabled]="!cleanMessage(commentEntity.message).length"
                        (click)="sendMessage()">
                        <mat-icon [ngClass]="{'disabled-icon': !cleanMessage(commentEntity.message).length}" class="uil uil-navigator"></mat-icon>
                    </span>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>

        <div class="row mb-10 users-list">
            <div class="col-md-12">
                <div class="pb-8">
                    <span class="date-edit">{{'commentbox.taginfo' | transloco}}</span>
                </div>
                <div class="d-flex" *transloco="let t">
                    <span class="align-self-center">{{'commentbox.collaborators' | transloco | capitaliz}}</span>
                    <div *ngFor="let colab of collaboratorList" class=" ml-5">
                        <ngx-avatars [name]="colab.name" size="25" textSizeRatio="2.5" borderColor="#EEEEEE" bgColor="#EEEEEE" fgColor="#0f0f0f">
                        </ngx-avatars>
                    </div>
                    <div class="dropdown dropup" [matTooltip]="collaboratorUsers ? (collaboratorUsers.length ? null : t('reusable.added')) : t('reusable.added')">
                        <a class="dropdown-toggle d-cursor-hand pl-6" data-toggle="dropdown" [ngClass]="collaboratorUsers?.length ? '' : 'disabled-link'">
                            <oi class="add-colab uil uil-plus-circle unicon-icon"></oi>
                        </a>
                        <ul class="dropdown-menu">
                            <li *ngFor="let user of collaboratorUsers"><a data-cy="shared-project-chat-panel__collaborator-dropdown" (click)="collaboratorDropdown(user)">{{user.name}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>